let cachedB64 = null;

export async function loadSignatureFont(doc) {
  try {
    if (!cachedB64) {
      const blob = await (await fetch("/media/signature.ttf")).blob();
      cachedB64 = await new Promise((res, rej) => {
        const r = new FileReader();
        r.onload = () => res(String(r.result).split(",")[1]);
        r.onerror = rej;
        r.readAsDataURL(blob);
      });
    }
    doc.addFileToVFS("signature.ttf", cachedB64);
    doc.addFont("signature.ttf", "signature", "normal");
    return true;
  } catch {
    return false;
  }
}
